import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { CrystallisationDetailsSection } from "../../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { LTABreakdownDetails } from "../../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownTypeOption } from "../../../../Common/SIPP/DrawdownDetails/DrawdownType";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { LessThanAge, PensionHelper } from "../../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DIAC } from "../../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import {
    getChooseAssetsToSellTable,
    getChooseAssetsToSwitchTable,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { ProtectionInformation } from "../../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { IllHealth } from "../../../../Common/SIPP/DrawdownDetails/IllHealth";
import { DrawdownCalculationAction } from "../../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { NewBusinessAction } from "../../../Actions/NewBusinessAction";
import { AdviserContextStoreStatic, NewBusinessStore } from "../../../Stores/Variable";
import { DrawdownPriceLock } from "../../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { PreADayPensionDetails } from "../../../../Common/SIPP/DrawdownDetails/PreADayPensionDetails";
import { Information } from "../../../../Common/SIPP/DrawdownDetails/Information";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { CrystallizationPerContribution } from "../../../../Common/SIPP/DrawdownDetails/CrystallizationPerContribution";
import { PensionProtection } from "../../../../Common/SIPP/DrawdownDetails/PensionProtection";
import {
    ChooseAssetsToSellAssets,
    ChooseAssetsToSwitchAssets,
} from "../../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { InvestmentPathSelection } from "../../../../Common/SIPP/DrawdownDetails/InvestmentPathSelection";
import { InvestmentSelectionAction } from "../../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { InstrumentSearchQuery } from "../../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { QuoteInstructionStore } from "../../../../NewQuoteWizard/Store/Variable";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { HistoricCrystallisationPage } from "../../../../../../../../Wrap/Models/Domains/Drawdown/HistoricCrystallisationPage";
import { ITFLSAction } from "../../../../TopUpWithITFLSWizard/Actions/ITFLSAction";
import { ProductType } from "../../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { IsRestrictedToPensionContributionWarningText, drawdownDetailsMessage } from "../../../../Common/Resource/Contents";
import { AllowanceDetails } from "../../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { PCLSSection } from "../../../../Common/SIPP/DrawdownDetails/PCLSSection";
import { UserStore } from "../../../../../../../Dashboard/Stroes/Variable";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { PensionArrangementAction } from "../../../../PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { TableKeys } from "../../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: ApplyModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
    assetsToSwitchTable: ChooseAssetsToSwitchAssets[];
    minimumDate_DisinvestNeed?: Date;
    minimumDate_DisinvestNoNeed?: Date;
    isDisinvest: Boolean;
    historicCrystallisation: HistoricCrystallisationPage;
    TailoredDrawdownAllowed: boolean;
    AdviceGiven: boolean;
    hasDrawdownArrangement?: boolean;
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
            isDisinvest: true,
            assetsToSwitchTable: [],
            historicCrystallisation: null,
            TailoredDrawdownAllowed: false,
            AdviceGiven: false,
            hasDrawdownArrangement: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.getQuoteInstruction();
        this.setState({ AdviceGiven: this.props.data?.PensionApply?.DrawdownModel?.InvestmentPathwayAnswers?.PersonalRecommendation ?? false })
        if (!this.props.data.PensionApply?.AdviceGiven) {
            this.onDataChange(this.props.onChange, { AdviceGiven: true }, this.props.data, "PensionApply");
        }
        this.setState({ assetsToSwitchTable: getChooseAssetsToSwitchTable(this.props.data.PensionApply) });
        if (
            !this.ageNeedIllHealth(this.props.data) &&
            !this.props.data?.PensionApply?.DrawdownModel?.InstructionId
        ) {
            this.setState({ isLoading: true });
            const params = getQueryParameters();
            DrawdownCalculationAction.postDrawdown(
                this.props.data?.PensionApply?.HierarchyId,
                null,
                (drawdownModel: DrawdownModel) => {
                    NewBusinessAction.getInstruction(params["id"]);
                    this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                }
            );
        }

        DrawdownCalculationAction.getMinimumPaymentDate("", true, true, (result) => {
            this.setState({
                minimumDate_DisinvestNeed: new Date(result.MinimumDateTime),
            });
        });

        DrawdownCalculationAction.getMinimumPaymentDate("", false, false, (result) => {
            this.setState({
                minimumDate_DisinvestNoNeed: new Date(result.MinimumDateTime),
            });
        });

        let allInstruments = getChooseAssetsToSellTable(this.props.data.PensionApply, true);
        const instrumentIds = allInstruments.map((ele) => ele.Id);
        let query: InstrumentSearchQuery = {
            CanBeSold: true,
            ProductIds: instrumentIds,
        };
        InvestmentSelectionAction.searchInstruments(query, this.props.data.PensionApply.HierarchyId, (result) => {
            let sellableInstruments: ChooseAssetsToSellAssets[] = [];
            const sellableInstrumentIds = new Set(result.map((ele) => ele.ProductId));

            allInstruments.forEach((instrument) => {
                if (sellableInstrumentIds.has(instrument.Id)) {
                    sellableInstruments.push(instrument);
                }
            });

            this.setState({ assetsTable: sellableInstruments }, () => {
                const isImmediateTaxFreeLumpSum =
                    this.props.data?.SelectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                        ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        
                if (isImmediateTaxFreeLumpSum) {
                    this.updatePensionCommencementLumpSumAllocations();
                }
            });
        });

        this.setState({
            TailoredDrawdownAllowed: this.props.data?.PensionApply?.PreRetirementInstrumentSelections?.Instruments.filter(
                (ele) =>
                    (ele.Instrument.Type == ProductType.OffPlatform))
                .every(ele => ele.Instrument.TailoredDrawdownAllowed == true)
        });

        if (this.props.data?.PensionApply?.ExistingPensionSubAccountHierarchyId) {
            PensionArrangementAction.GetPensionArrangementDetails(this.props.data.PensionApply.ExistingPensionSubAccountHierarchyId, true, (v) => {
                this.setDrawdownArrangement(v);
            });
        }
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);
        const data = this.props.data as ApplyModel
        const preData = prevProps.data as ApplyModel
        if (
            data?.PensionApply?.DrawdownModel?.IsAcrossAllAssets != undefined &&
            preData?.PensionApply?.DrawdownModel?.IsAcrossAllAssets !=
            this.props.data?.PensionApply?.DrawdownModel?.IsAcrossAllAssets
        ) {
            this.setIsDisinvest();
        }
        if (this.props.data.PensionApply.ExistingPensionSubAccountHierarchyId) {
            ITFLSAction.getHistoricCrystallisation(
                this.props.data.PensionApply.ExistingPensionSubAccountHierarchyId,
                (result) => {
                    this.setState({ historicCrystallisation: result });
                }
            );
        }

        if (
            JSON.stringify(prevProps.data?.PensionApply?.DrawdownModel) !== 
            JSON.stringify(this.props.data?.PensionApply?.DrawdownModel)) {
            this.updatePensionCommencementLumpSumAllocations();
        }
    }

    isValid() {
        const flag = super.isValid();

        if (this.needIllHealth(this.props.data)) {
            this.props.showErrorMsgPopUp([
                drawdownDetailsMessage.NeedIllHealthErrorMessage,
            ]);
            return false;
        }

        var isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        if (!this.state.AdviceGiven && !isNotFirstCrystallisation && !UserStore.getUserInfo().IsInternalUser) {
            this.props.showErrorMsgPopUp(["To continue, you must have given financial advice."]);
            return false;
        }
        var isRestrictedProtection = false;
        if (this.props.data?.PensionApply?.HasPensionProtection && this.props.data?.PensionApply?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.PensionApply?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        if (this.state.TailoredDrawdownAllowed == false && this.props.data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Regular) {
            return false
        }

        return flag && !isRestrictedProtection;
    }

    componentWillUpdate(nextProps, nextState): void {
        super.componentWillUpdate(nextProps, nextState);

        //assetsTable state change
        if (this.state.assetsTable.length == 0 && nextState.assetsTable.length > 0) {
            this.setIsDisinvest(nextState.assetsTable);
        }
    }

    private updatePensionCommencementLumpSumAllocations() {
        const { data } = this.props;
        const drawdownModel = data?.PensionApply?.DrawdownModel;
        if (!drawdownModel || drawdownModel.DrawdownType == DrawdownType.Regular) return;
        
        const availableCash = drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount || 0;
        const pclsAmount = drawdownModel?.TaxFreeLumpSum?.Amount || 0;
        
        if (!this.state.assetsTable || this.state.assetsTable.length === 0) return;
        
        const cashAsset = this.state.assetsTable.find(a => a.Assets.toUpperCase() === "GBP CASH");
        if (!cashAsset) return;
        
        if (availableCash >= pclsAmount) {
            const pclsAllocations = [{
                ProductId: cashAsset.Id,
                Name: cashAsset.Assets,
                Percentage: 100,
                Type: cashAsset.ProductType
            }];

            const changes = {
                PensionCommencementLumpSumAllocations: pclsAllocations
            };
            
            this.onDataChange(
                (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "PensionApply"),
                changes,
                this.props.data.PensionApply,
                "DrawdownModel"
            );
        }
    }

    public allocateAcrossAllAssets(assets: ChooseAssetsToSellAssets[]) {
        assets = assets.filter((asset) => asset.ProductType !== ProductType.OffPlatform);

        const totalAmount = assets.reduce((total, asset) => total + asset.MarketValue.Amount, 0);
        let adjustedAssets = assets.map((asset) => ({
            Name: asset.Assets,
            Percentage: Math.floor((asset.MarketValue.Amount / totalAmount) * 10000) / 100,
            ProductId: asset.Id,
            Type: asset.ProductType,
        }));

        let totalPercentage = adjustedAssets.reduce((sum, asset) => sum + asset.Percentage * 100, 0) / 100;
        let remainder = (100 * 100 - totalPercentage * 100) / 100;

        if (adjustedAssets.length > 0) {
            for (let i = 0; i < Math.abs(remainder * 100); i++) {
                if (remainder > 0) {
                    adjustedAssets[i % adjustedAssets.length].Percentage = (adjustedAssets[i % adjustedAssets.length].Percentage * 100 + 1) / 100;
                } else {
                    adjustedAssets[i % adjustedAssets.length].Percentage = (adjustedAssets[i % adjustedAssets.length].Percentage * 100 - 1) / 100;
                }
            }
        }

        const changes = {
            PensionCommencementLumpSumAllocations: adjustedAssets
        };

        this.onDataChange(
            (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "PensionApply"),
            changes,
            this.props.data.PensionApply,
            "DrawdownModel"
        );
    }

    private setDrawdownArrangement(arrangementDetails) {
        arrangementDetails.forEach(v => {
            if (v.Type != PensionArrangementType.Accumulation) {
                this.setState({ hasDrawdownArrangement: true });
            }
        });
    }

    private getQuoteInstruction() {
        let data = this.props.data;
        const quoteData: QuoteModel = QuoteInstructionStore.getData();
        if (quoteData) {
            if (!data?.PensionApply?.DrawdownModel) {
                let drawdownModel = quoteData.PensionQuote?.DrawdownModel;
                if (drawdownModel) {
                    drawdownModel.HierarchyId = data?.PensionApply?.HierarchyId;
                    drawdownModel.InstructionId = null;
                }
                this.setState({ isLoading: true });
                const params = getQueryParameters();
                DrawdownCalculationAction.postDrawdown(
                    this.props.data?.PensionApply?.HierarchyId,
                    drawdownModel,
                    (drawdownModel: DrawdownModel) => {
                        NewBusinessAction.getInstruction(params["id"]);
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                    }
                );
            }
        }
    }

    private getComponentProps = (data: ApplyModel, onChange) => {
        return {
            data: data?.PensionApply?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "PensionApply"),
                    v,
                    data.PensionApply,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: this.props.data?.PensionApply?.HierarchyId,
        };
    };

    private getIllustrationChargeProps = (data: ApplyModel, onChange) => {
        return {
            data: data?.PensionApply,
            onChange: (v) => {
                this.onDataChange(
                    onChange,
                    v,
                    data,
                    "PensionApply"
                );
            },
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: this.props.data?.PensionApply?.HierarchyId,
        };
    } 

    private setIsDisinvest(assetsTable: ChooseAssetsToSellAssets[] = []) {
        let assetData = this.state.assetsTable.length > 0 ? this.state.assetsTable : assetsTable;
        let assetAllocations = this.props.data?.PensionApply?.DrawdownModel?.PensionCommencementLumpSumAllocations;
        let isAcrossAllAssets = this.props.data?.PensionApply?.DrawdownModel?.IsAcrossAllAssets ?? true;

        //if the asset allocation got 100% cash, then disinvestment is not needed
        if (
            (isAcrossAllAssets && assetData && assetData.length == 1) ||
            (!isAcrossAllAssets &&
                assetAllocations &&
                assetData &&
                assetData.some(
                    (x) =>
                        x.Assets.toUpperCase() == "GBP CASH" &&
                        assetAllocations.some((y) => y.ProductId == x.Id && y.Percentage == 100)
                ))
        ) {
            this.setState({
                isDisinvest: false,
            });
            return;
        }

        this.setState({
            isDisinvest: true,
        });
    }

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const originType =
            this.state.originType || NewBusinessStore.getData()?.PensionApply?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.PensionApply?.DrawdownModel?.DrawdownType;
        const _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.PensionApply.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        NewBusinessAction.postInstruction(2, _data, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data: ApplyModel) {
        return (
            this.ageNeedIllHealth(data) &&
            !data?.PensionApply?.DrawdownModel?.InstructionId
        );
    }

    private ageNeedIllHealth(data: ApplyModel) {
        return data?.PensionApply?.PensionProtection?.PensionSchemeSpecificProtection?.ProtectedRetirementAge
            ? false
            : LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
    }

    private getTotalPea(data: ApplyModel) {
        if (this.state.assetsTable?.length === 0) return;

        const preRetirementPea = PensionHelper.getPaymentsPeaTotal(data?.PensionApply?.PreRetirementInstrumentSelections?.Instruments);
        const postRetirementPea = PensionHelper.getPaymentsPeaTotal(data?.PensionApply?.PostRetirementInstrumentSelections?.Instruments);
        const transferPea = PensionHelper.getTransfersPeaTotal(data?.PensionApply?.PensionTransfers);

        const drawdownModel = data?.PensionApply?.DrawdownModel;
        const taxFreeLumpSum = drawdownModel?.TaxFreeLumpSum?.Amount;
        
        let disinvestmentPea = 0;

        if (drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount < taxFreeLumpSum) {
            if (drawdownModel?.IsAcrossAllAssets) {
                const assetsAmount = this.state.assetsTable
                    .filter((asset) => asset.ProductType !== ProductType.OffPlatform && asset.ProductType !== ProductType.Cash)
                    .reduce((total, asset) => total + asset.MarketValue.Amount, 0);

                const totalAmount = this.state.assetsTable
                    .filter((asset) => asset.ProductType !== ProductType.OffPlatform)
                    .reduce((total, asset) => total + asset.MarketValue.Amount, 0);

                if (totalAmount > 0) {
                    disinvestmentPea = (assetsAmount / totalAmount) * taxFreeLumpSum;
                }
            } else {
                disinvestmentPea = PensionHelper.getDisinvestmentPeaTotal(drawdownModel?.PensionCommencementLumpSumAllocations, taxFreeLumpSum);
            }
        }

        return preRetirementPea + postRetirementPea + transferPea + taxFreeLumpSum - disinvestmentPea;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const adviser = AdviserContextStoreStatic.getData();
        const isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const isImmediateTaxFreeLumpSum =
            data?.SelectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;

        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.setState({ isLoading: true });
                        const params = getQueryParameters();
                        DrawdownCalculationAction.postDrawdown(
                            this.props.data?.PensionApply?.HierarchyId,
                            null,
                            (drawdownModel: DrawdownModel) => {
                                NewBusinessAction.getInstruction(params["id"]);
                                this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                            },
                            true
                        );
                    }}
                />
            );
        }       
        return ( 
            <PartLoading isLoading={this.state.isLoading}>
                <WizardLinter
                    status={EWizardLinterStatus.PleaseComplete}
                    enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.Npr)}
                >
                    <h2 className="mb-40">Drawdown details</h2>
                    <>
                        {this.state.TailoredDrawdownAllowed == false && data?.PensionApply?.DrawdownModel?.DrawdownType == DrawdownType.Regular && (
                            <Alert alertType={AlertType.Error} message={drawdownDetailsMessage.HasTailoredDrawdownErrorMessage} />
                        )}
                        <PreADayPensionDetails {...this.getComponentProps(data, onChange)} />

                        <hr className="mb-20" />

                        {data?.PensionApply?.DrawdownModel?.PreADay == false && (
                            <>
                                <PensionProtection
                                    {...this.props}
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.PensionApply}
                                    onChange={(v) => this.onDataChange(onChange, v, data, "PensionApply")}
                                    process={ProcessType.NB}
                                />
                                <ProtectionInformation
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.NB}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                />
                                <hr className="mb-20" />
                            </>
                        )}
                       

                        {data?.PensionApply?.DrawdownModel?.PreADay == false && (
                            <>
                                <InvestmentPathSelection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.PensionApply?.DrawdownModel?.InvestmentPathwayAnswers}
                                    activityType={data?.ActivityType}
                                    isFirstCrystallisation={!isNotFirstCrystallisation}
                                    hardBlockforAdviserUser={UserStore.getUserInfo().IsAdviser && !this.state.hasDrawdownArrangement}
                                    onChange={(v) => {
                                        this.setState({ AdviceGiven: v.PersonalRecommendation })
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "PensionApply"),
                                            { InvestmentPathwayAnswers: v },
                                            data.PensionApply,
                                            "DrawdownModel"
                                        );
                                        this.onDataChange(
                                            (changes) =>
                                                this.onDataChange(onChange, changes, this.props.data, "PensionApply"),
                                            { AdviceGiven: v.PersonalRecommendation },
                                            this.props.data.PensionApply,
                                            "FinancialAdvice"
                                        );
                                        this.onDataChange(
                                            this.props.onChange,
                                            { AdviceGiven: v.PersonalRecommendation },
                                            this.props.data,
                                            "PensionApply"
                                        );
                                    }}
                                />

                                <hr className="mb-20" />

                                <DrawdownTypeOption
                                    originType={
                                        this.state.originType ||
                                        NewBusinessStore.getData()?.PensionApply?.DrawdownModel?.DrawdownType
                                    }
                                    {...this.getComponentProps(data, onChange)}
                                    isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                    activityType={data?.ActivityType}
                                    PersonalRecommendation={
                                        data?.PensionApply?.DrawdownModel?.InvestmentPathwayAnswers
                                            ?.PersonalRecommendation
                                    }
                                    canCreateRegularCrystallisation={!data?.PensionApply.DrawdownModel?.IsIllHealth}
                                />

                                {data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Regular && (
                                    <>
                                        <RegularCrystallisation
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.NB}
                                            doCalculation={() => this.doCalculation()}
                                            hierarchyId={this.props.data?.PensionApply.HierarchyId}
                                            minimumDate={
                                                this.state.isDisinvest
                                                    ? this.state.minimumDate_DisinvestNeed
                                                    : this.state.minimumDate_DisinvestNoNeed
                                            }
                                        />
                                        <hr className="mb-20" />
                                    </>
                                )}

                                {(data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Capped ||
                                    data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Flexible) && (
                                        <>
                                            <CrystallisationDetailsSection
                                                isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                                                modelData={this.props.data?.PensionApply}
                                                processType={ProcessType.NB}
                                                cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                                                doCalculation={() => this.doCalculation()}
                                                {...this.getComponentProps(data, onChange)}
                                                pensionProtection={data?.PensionApply?.PensionProtection}
                                            />
                                        </>
                                    )}

                                {(data?.PensionApply?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.PensionApply?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                !hasPrimaryProtection(data?.PensionApply?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.PensionApply?.PensionProtection) && (
                                    <>
                                        <LTABreakdownDetails
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.NB}
                                            lessThan75={ageLessThan75}
                                            hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionApply)}
                                        />
                                    </>
                                )}

                                <AllowanceDetails
                                    doCalculation={() => this.doCalculation()}
                                    {...this.getComponentProps(data, onChange)}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionApply)}
                                    process={ProcessType.NB}
                                />
                                <PCLSSection {...this.getComponentProps(data, onChange)} data={data?.PensionApply?.DrawdownModel} />
                                <TaxFreeLumpSumPayment
                                    doCalculation={this.doCalculation}
                                    process={ProcessType.NB}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                    {...this.getComponentProps(data, onChange)}
                                    lessThan75={LessThanAge(
                                        75,
                                        JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth)
                                    )}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionApply)}
                                />
                                {data?.SelectedProducts.find((ele) =>
                                    SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
                                )?.PensionType == PensionType.ImmediateTaxFreeLumpSum && (
                                        <CrystallizationPerContribution
                                            {...this.getComponentProps(data, onChange)}
                                            modelData={this.props.data?.PensionApply}
                                        />
                                    )}
                                {data?.PensionApply?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                                    <DIAC
                                        {...this.getComponentProps(data, onChange)}
                                        modelData={this.props.data?.PensionApply}
                                        existingAccount={false}
                                    />
                                )}
                                <OAC
                                    readonly={true}
                                    type={SubAccountType.Npr}
                                    onChange={(v) => { }}
                                    data={{
                                        OngoingAdviceCharge:
                                            data?.PensionApply?.DrawdownModel?.DrawdownAdviserCharge
                                                ?.OngoingAdviserCharge,
                                    }}
                                    onRef={(ref) => this.appendChild(ref)}
                                />
                                <ChargesOnIllustration {...this.getIllustrationChargeProps(data, onChange)} />
                                <hr className="mb-20" />
                                <DrawdownPriceLock
                                    {...this.getComponentProps(data, onChange)}
                                    subaccountHierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                                    totalPea={this.getTotalPea(data)}
                                />
                                {showChooseAssetstoSell(
                                    data?.PensionApply?.DrawdownModel,
                                    ChooseAssetsToSellFor.Drawdown
                                ) && !isImmediateTaxFreeLumpSum && (
                                        <>
                                            <hr />
                                            <ChooseAssetsToSell
                                                {...this.getComponentProps(data, onChange)}
                                                tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                                assets={this.state.assetsTable}
                                                disableOffPlatform={true}
                                            />
                                            {!data?.PensionApply?.DrawdownModel?.IsAcrossAllAssets && (
                                                <ChooseAssetsToSellTable
                                                    modelData={data?.PensionApply?.DrawdownModel}
                                                    data={
                                                        data?.PensionApply?.DrawdownModel
                                                            ?.PensionCommencementLumpSumAllocations || []
                                                    }
                                                    reason={ChooseAssetsToSellFor.Drawdown}
                                                    tableData={this.state.assetsTable}
                                                    onRef={(ref) => this.appendChild(ref)}
                                                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                                    onChange={(v) => {
                                                        this.onDataChange(
                                                            (changes) =>
                                                                this.onDataChange(
                                                                    onChange,
                                                                    changes,
                                                                    data,
                                                                    "PensionApply"
                                                                ),
                                                            { PensionCommencementLumpSumAllocations: v },
                                                            data.PensionApply,
                                                            "DrawdownModel"
                                                        );
                                                        this.setIsDisinvest();
                                                    }}
                                                    processType={ProcessType.NB}
                                                    disableOffPlatform={true}
                                                />
                                            )}
                                        </>
                                    )}
                            </>
                        )}
                    </>
                </WizardLinter>
            </PartLoading>
        );
    }
}
